import { gql } from '@apollo/client';

export const QUERY_VEHICLE = gql`
  query vehicle {
    vehicleTypes {
      id
      name
    }
    vehicleMakes {
      id
      name
    }
  }
`;
